import theme from '@vromo/ui/components/theme';
import { CSSProperties } from 'react';

export default {
    deadlineRadioLabel: {
        backgroundColor: theme.ultraLightGrey,
        borderRadius: '10px',
        flex: 1,
        marginRight: '5px',
        marginLeft: '5px',
        padding: '5px'
    },
    deadlineOption: {
        display: 'flex',
        flex: 1,
        flexDirection: 'column'
    } as CSSProperties
};
